import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email.").required("Email is required."),
});

export const initialValues = {
  email: "",
};
